import { isGateOpen, getTierForGate, prefetchTiers, getLimit } from '@hotjar/allowances';

/**
 * Angular service wrapper for Allowances package
 *
 * @typedef {Object} Context
 * @property {string} Context.type - only 'site' for now
 * @property {string} Context.id - id of the the context
 */
angular.module('hjApp').service('Allowances', function () {
    /**
     * @param {string} gate - valid gate name defined in @hotjar/allowances/src/types
     * @param {Context} context
     * @returns {(boolean|null)}
     */
    this.isGateOpen = isGateOpen;

    /**
     * @param {string} gate - valid gate name defined in @hotjar/allowances/src/types
     * @param {Context} context
     * @returns {Promise<('basic'|'plus'|'business'|'scale'|null)>}
     */
    this.getTierForGate = getTierForGate;

    /**
     * @param {string} gate - valid gate name defined in @hotjar/allowances/src/types
     * @param {Context} context
     * @returns {void}
     */
    this.prefetchTiers = prefetchTiers;

    /**
     * @param {string} limit - valid limit name defined in @hotjar/allowances/src/types
     * @param {Context} context
     * @returns {Promise<number>}
     */
    this.getLimit = getLimit;
});
